// React
import React, { useEffect, useState, useContext, useRef } from "react";
// React
// CSS
import styles from "./AdsContainer.module.css";
import "./videoConfig.css";
// CSS
// Models
import { I_AdData } from "../../Models/interfaces";
// Models
// Services
// Services
// Contexts
import { UserTokenContext } from "../../Contexts/userToken";
// Contexts
// Modules
import ReactPlayer from "react-player";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
// Modules
// Components
import PendingManager from "../../Components/PendingManager/PendingManager";
import { BiArrowBack } from "react-icons/bi";
import { toast } from "react-toastify";
import { getRandomAdService } from "../../Services/Ads/get/getRandomAdService";
import { submitAdEndService } from "../../Services/Ads/post/SubmitAdEndService";
// Components

type AdsContainerProps = {
  setIsNeedFullScreen: React.Dispatch<React.SetStateAction<boolean>>;
};

const AdsContainer: React.FunctionComponent<AdsContainerProps> = ({
  setIsNeedFullScreen,
}) => {
  // STATES
  const [adData, setAdData] = useState<I_AdData>({
    count: 1,
    gift: 2001,
    id: 32172231,
    price: 2,
    title: "",
    video_url: "",
  });
  //
  const [isPending, setIsPending] = useState<boolean>(true);
  //
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  // STATES
  /********************************************* */
  /********************************************* */
  /********************************************* */
  /********************************************* */
  //
  /********************************************* */
  /********************************************* */
  /********************************************* */
  /********************************************* */
  // Contexts
  const userToken = useContext(UserTokenContext);
  // Contexts
  /********************************************* */
  /********************************************* */
  /********************************************* */
  /********************************************* */
  // Refs
  const playerContainerRef = useRef<any>(null);
  // Refs
  /********************************************* */
  /********************************************* */
  /********************************************* */
  /********************************************* */
  // Constants
  const navigate = useNavigate();
  // Constants
  /********************************************* */
  /********************************************* */
  /********************************************* */
  /********************************************* */
  // Life Cycles
  useEffect(() => {
    if (!playerContainerRef.current) return;
    if (!playerContainerRef.current.children) return;
    playerContainerRef.current.children[0].style.width = `${
      window.innerWidth * 0.95
    }px`;
    getRandomAdService(userToken)
      .then(({ data: { data } }) => {
        console.log(data);
        if (
          data.video_url === null ||
          data.video_url === "null" ||
          data.video_url === undefined ||
          data.video_url === "undefined"
        ) {
          Swal.fire({
            icon: "error",
            title: "در حال حاضر تبلیغی موجود نیست",
          }).then(() => {
            navigate("/");
            setAdData({
              count: 1,
              gift: 2001,
              id: 32172231,
              price: 2,
              title: "",
              video_url: "",
            });
          });
          return;
        } else {
          setAdData({
            count: data.count,
            gift: data.gift,
            id: data.id,
            price: data.price,
            title: data.title,
            video_url: data.video_url,
          });
          setIsPending(false);
        }
      })
      .catch((err) => {
        setIsPending(false);
        console.log(err);
        toast(
          err.response.data.message ? err.response.data.message : err.message
        );
      });
  }, [userToken, navigate]);
  //
  useEffect(() => {
    setIsNeedFullScreen(true);
    const eventFunction = () => {
      navigate("/");
    };
    window.addEventListener("popstate", eventFunction);
    return () => {
      setIsNeedFullScreen(false);
      window.removeEventListener("popstate", eventFunction);
    };
  }, [setIsNeedFullScreen, navigate]);
  //
  useEffect(() => {
    if (!isPending) return;
    const btn = document.getElementById("test")!;
    btn.addEventListener("click", () => {
      const videoEl = document.getElementsByTagName("video")!;
      [...videoEl].forEach((item) => {
        item.click();
        item
          .play()
          .then(() => {
            console.log("playing ", item);
          })
          .catch((err) => {
            console.log(err);
          });
      });
    });

    setTimeout(() => {
      btn.click();
      setIsPlaying((prevState) => !prevState);
    }, 200);
  }, [isPending]);
  // Life Cycles
  /********************************************* */
  /********************************************* */
  /********************************************* */
  /********************************************* */
  return (
    <div
      className={`${styles.adsContainer} w-full relative flex items-center justify-center bg-black`}
      onClick={() => {}}
    >
      <button className="hidden" id="test">
        rend
      </button>
      <BiArrowBack
        className="absolute bg-white rounded-full w-7 h-7 text-black left-4 top-4 text-2xl"
        onClick={() => {
          console.log(isPlaying);
          Swal.fire({
            icon: "question",
            title: "با برگشتن به صفحه ی اصلی هیچ جایزه ای دریافت نمی شود ",
            showCancelButton: true,
            showConfirmButton: true,
            cancelButtonText: "ادامه مشاهده",
            confirmButtonText: "برگشتن به صفحه اصلی",
          }).then(({ isConfirmed }) => {
            if (isConfirmed) {
              navigate(-1);
              return;
            }
          });
        }}
      />
      <div className="player-wrapper" ref={playerContainerRef}>
        <ReactPlayer
          url={adData.video_url.replace(/(http[^\s])/i, "https:").replace("::", ":")}
          playing={true}
          volume={1}
          muted={false}
          controls={false}
          playsinline={true}
          config={{}}
          onReady={(e) => {
            setIsPlaying((prevState) => !prevState);
            if (
              String(window.navigator.userAgent).includes("ios") ||
              String(window.navigator.userAgent).includes("IOS") ||
              String(window.navigator.userAgent).includes("iPhone") ||
              String(window.navigator.userAgent).includes("iPhone; ") ||
              String(window.navigator.userAgent).includes("Safari")
            ) {
              Swal.fire({
                icon: "info",
                title: "ویدیو آماده است",
                cancelButtonText: "بزن بریم",
                confirmButtonText: "برگشتن به صفحه اصلی",
                showCancelButton: true,
              }).then(({ isConfirmed }) => {
                if (!isConfirmed) {
                  const videoEl = document.getElementsByTagName("video")!;
                  [...videoEl].forEach((item) => {
                    item.click();
                    item
                      .play()
                      .then(() => {
                        console.log("playing ", item);
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                  });
                  return;
                }
                navigate("/");
              });
              return;
            }
          }}
          onEnded={() => {
            if (
              adData.gift === 2001 ||
              adData.id === 32172231 ||
              adData.price === 2
            )
              return;
            Swal.fire({
              icon: "success",
              title: ` مبلغ ${adData.gift} تومان به حساب شما اضافه میشود`,
            }).then(() => {
              navigate("/");
              submitAdEndService(userToken, adData?.id)
                .then(() => {})
                .catch((err) => {
                  console.log(err);
                });
            });
          }}
        />
      </div>
      <div className="absolute w-full">
        <PendingManager data={<></>} isPending={isPending} />
      </div>
    </div>
  );
};

export default AdsContainer;
